import React, { useEffect, useState, useRef } from "react";
import Header from "./Header";
import "../css/HomePage.css";
import bottom_car_patch from "../img/gii.png";
import tyre_doodle from "../img/tyre_doodle.png";
import ic_create_new_job from "../img/ic_create_new_job.png";
import axios from "axios";
import ic_search_tire_loader from "../img/ic_tire_loader.png";
import ic_no_data from "../img/ic_no_data.svg";
import Job_detail_popup from "./Job_detail_popup";

function HomePage() {

    const currentIndexOfSwipeRef = useRef(0);
    const [isCallingSwipeJobListDetailsAPIState, setIsCallingSwipeJobListDetailsAPIState] = useState(false);
    const [isCallingJobListDetailsAPIState, setIsCallingJobListDetailsAPIState] = useState(false);
    const [showHideJobDetailsPopupState, setShowHideJobDetailsPopupState] = useState(false);
    const [jobDetailArrayState, setJobDetailArrayState] = useState(null);
    const [isCallingApi, setIsCallingApi] = useState(false);
    const [arrayOfJobsState, setArrayOfJobsState] = useState(null);

    const getPreviousJobList = () => {

        setIsCallingApi(true);

        axios.get(`${process.env.REACT_APP_BACK_END_BASE_URL}/Search_Customer/joblist/12100001`).then((res) => {
            setTimeout(() => {
                setIsCallingApi(false);
            }, 1000)
            setArrayOfJobsState(res.data.jsont)

        }).catch((err) => {
            setTimeout(() => {
                setIsCallingApi(false);
            }, 1000)
            console.log("err ", err);
        })
    }

    const callJobDetailsAPI = (job_number_from_click) => {

        console.log("job_number_from_click ", job_number_from_click)

        setIsCallingJobListDetailsAPIState(true);

        axios.get(`${process.env.REACT_APP_BACK_END_BASE_URL}/JobcardEdit/${job_number_from_click}/HO`).then((res) => {
            console.log("res is ", res);
            setJobDetailArrayState(res.data.jsont)
            setShowHideJobDetailsPopupState(true)
            setIsCallingJobListDetailsAPIState(false);
            setIsCallingSwipeJobListDetailsAPIState(false)
        }).catch((err) => {
            console.log("err is ", err);
            setIsCallingJobListDetailsAPIState(false);
            setIsCallingSwipeJobListDetailsAPIState(false)

        })
    }

    const clickedOnJobListItem = (job_number_from_click, index) => {

        currentIndexOfSwipeRef.current = index;

        callJobDetailsAPI(job_number_from_click)
    }

    const closeJobPopup = () => [
        setShowHideJobDetailsPopupState(prev => !prev)
    ]

    const swiped = (swipeDirection) => {

        if (arrayOfJobsState != null) {

            if (swipeDirection == "right") {

                if (currentIndexOfSwipeRef.current + 1 < arrayOfJobsState.length) {

                    setIsCallingSwipeJobListDetailsAPIState(true)
                    callJobDetailsAPI(arrayOfJobsState[currentIndexOfSwipeRef.current + 1]['JOB NO']);
                    currentIndexOfSwipeRef.current = currentIndexOfSwipeRef.current + 1;
                }

            } else {

                if (currentIndexOfSwipeRef.current - 1 >= 0) {

                    setIsCallingSwipeJobListDetailsAPIState(true)
                    callJobDetailsAPI(arrayOfJobsState[currentIndexOfSwipeRef.current - 1]['JOB NO']);
                    currentIndexOfSwipeRef.current = currentIndexOfSwipeRef.current - 1;
                }
            }
        }

    }

    useEffect(() => {
        getPreviousJobList();
    }, [])

    return (
        <div className="HomePage-root-container page_background">

            <img src={tyre_doodle} className="HomePage-bottom-tyre-patch-image" />

            <div className="HomePage-top-layer-container">
                <Header />
                <div className="HomePage-content-container">
                    <div className="HomePage-create-new-job-container mt-4">
                        <a className="HomePage-create-new-job" href="/create-new-job"><img src={ic_create_new_job} className="me-1" />Create New Job</a>
                    </div>

                    <div className="HomePage-show-job-list mt-4">

                        {isCallingApi ?
                            <div className="CustomerDetailsPage-searching-loader-text-div"><span className="CustomerDetailsPage_search_span"><img className="rotate me-2" src={ic_search_tire_loader} />Loading Joblist...</span></div>
                            :
                            arrayOfJobsState != null ?
                                arrayOfJobsState.length == 0 ?
                                    <div className="HomePage-empty-array-container">
                                        <img src={ic_no_data} />
                                        <label className="mt-4">No joblist found</label>
                                    </div>
                                    :
                                    <table className="HomePage-table">
                                        <thead>
                                            <tr>
                                                <th><div className="CreateNewJob-sl-no-container">JOB NO.</div></th>
                                                <th><div>NAME</div></th>
                                                <th><div>ORDER DATE</div></th>
                                                <th><div>PLATE NO.</div></th>
                                                <th><div>TECH_ASSND</div></th>

                                            </tr>
                                        </thead>
                                        <tbody>

                                            {
                                                arrayOfJobsState != null ?
                                                    arrayOfJobsState.map((item, index) => {
                                                        return (
                                                            <tr className="HomePage-table-single-item" onClick={() => clickedOnJobListItem(item['JOB NO'], index)}>
                                                                <td><div>{item['JOB NO']}</div></td>
                                                                <td><div>{item.NAME} <label className="HomePage-table-single-item-sub-detail">{item["MOBILE NO"]}</label> </div></td>

                                                                <td><div>{item["ORDER DATE"]} <label className="HomePage-table-single-item-sub-detail">{item.STATUS}</label></div></td>

                                                                <td><div>{item["PLATE NO"]}</div></td>
                                                                <td><div>{item.TECH_ASSND}</div></td>

                                                            </tr>
                                                        )
                                                    })
                                                    :
                                                    null
                                            }


                                        </tbody>
                                    </table>
                                :
                                <div className="HomePage-empty-array-container">
                                    <img src={ic_no_data} />
                                    <label className="mt-4">Joblist not available</label>
                                </div>
                        }


                    </div>
                </div>
            </div>

            {
                isCallingJobListDetailsAPIState ?
                    <div className="Page-popup-outer">
                        <div className="Page-popup-inner">
                            <div className="HomePage-job-details-search-container">
                                <div className="CustomerDetailsPage-searching-loader-text-div"><span className="CustomerDetailsPage_search_span"><img className="rotate me-2" src={ic_search_tire_loader} />Loading Job Details...</span></div>
                            </div>
                        </div>
                    </div>
                    :
                    null
            }

            {showHideJobDetailsPopupState &&
                <div className="Page-popup-outer">
                    <div className="Page-popup-inner">
                        <Job_detail_popup jobDetailArrayState={jobDetailArrayState} closeJobPopup={closeJobPopup} swiped={swiped}
                            startingJobNumber={
                                arrayOfJobsState != null ?
                                    arrayOfJobsState.length > 0 ?
                                        arrayOfJobsState[0]['JOB NO']
                                        : 0
                                    : 0
                            }
                            endJobNumber={
                                arrayOfJobsState != null ?
                                    arrayOfJobsState.length > 0 ?
                                        arrayOfJobsState[arrayOfJobsState.length - 1]['JOB NO']
                                        : 0
                                    : 0
                            }
                        />
                    </div>
                </div>
            }

            {
                isCallingSwipeJobListDetailsAPIState ?

                    <div className="HomePage-job-details-swipe-search-container">
                        <button onClick={() => setIsCallingSwipeJobListDetailsAPIState(prev => !prev)} className="common_close_button m-2">Cancel</button>
                        <div className="CustomerDetailsPage-searching-loader-text-div"><span className="CustomerDetailsPage_search_span"><img className="rotate me-2" src={ic_search_tire_loader} />Loading Job Details ...</span></div>
                    </div>
                    :
                    null
            }



        </div>
    )
}

export default HomePage;